<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->
      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="loadingTable"
      >
        <loading />
      </div>

      <!-- dataTable y botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
        <div style="position: relative; z-index: 5">
          <div class="d-flex" style="position: absolute">
            <agregar-seccion-modal :listaModulos="listaModulos" />

            <!-- Filtro -->
            <!-- <filtro-secciones /> -->
          </div>
        </div>
        <data-table
          v-if="acciones.length > 0"
          :headers="headers"
          :data="dataTableAux"
          :acciones="acciones"
          :max="10"
          paginacion
          buscar
          idtabla="secciones"
          exportarExcel
          :seleccionar="obtenerFilaSeleccionada"
        />

        <not-found-table
          v-else
          :text="'No se encontraron registros de modulos'"
          class="justify-content-center w-100 pt-5"
        />
      </div>
    </div>

    <!-- Modales para acciones para filas -->
    <actualizar-seccion-modal
      :data="dataSeccionActualizar"
      :listaModulos="listaModulos"
    />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import DataTable from "../../../common/DataTable";
import AgregarSeccionModal from "../../../modals/superadministrador/Secciones/AgregarSeccionModal";
import ActualizarSeccionModal from "../../../modals/superadministrador/Secciones/ActualizarSeccionModal";

// Not Found
import NotFoundTable from "../../../common/NotFoundTable";

import {
  getSecciones,
  deleteSeccion,
  activarDesactivarSeccion,
} from "../../../../constants/superadministrador";

export default {
  props: ["data", "listaSecciones", "listaModulos"],
  data() {
    return {
      headers: [
        "Nombre",
        "Referencia",
        "Modulo",
        "Creación",
        "Modificado por",
        "Fecha creación",
        "Ultima modificación",
        "Acciones",
      ],
      acciones: [],
      dataSeccionActualizar: [],
      dataTableAux: this.data,
    };
  },
  components: {
    DataTable,
    AgregarSeccionModal,
    ActualizarSeccionModal,
    NotFoundTable,
  },
  computed: {
    ...mapState(["loading", "loadingTable", "token"]),
  },
  methods: {
    ...mapActions("superadministrador", ["actionSetDataSecciones"]),

    ...mapActions(["ActionSetVisibleModalEditar"]),

    async generarBotonesAcciones() {
      let me = this;

      await me.dataTableAux.map((item, index) => {
        let estado_seccion = item.data_complementaria.estado;

        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon:
              estado_seccion == 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: estado_seccion == 1 ? "Desactivar" : "Activar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    async actualizacionGenerarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataTableAux.map((item, index) => {
        let estado_seccion = item.data_complementaria.estado;

        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon:
              estado_seccion == 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: estado_seccion == 1 ? "Desactivar" : "Activar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    obtenerFilaSeleccionada(fila) {
      let textoAuxiliar = "";
      let data_fila = this.data[fila.id];
      let id_seccion =
        this.dataTableAux[fila.id].data_complementaria.id_seccion;
      let nombre_seccion = this.dataTableAux[fila.id].data[0];
      let estado_seccion =
        this.dataTableAux[fila.id].data_complementaria.estado;

      if (fila.accion == "Editar") {
        /*

        */
        this.dataSeccionActualizar = data_fila;
        this.ActionSetVisibleModalEditar(true);
        /*
        /*

        */
      } else if (fila.accion == "Activar" || fila.accion == "Desactivar") {
        /*
        
        */

        if (estado_seccion == 1) {
          textoAuxiliar =
            "¿Desea desactivar la Sección '" + nombre_seccion + "'?";
        } else {
          textoAuxiliar = "¿Desea activar la Sección '" + nombre_seccion + "'?";
        }

        //
        this.$vToastify.prompt(textoAuxiliar).then(
          (respuesta) =>
            respuesta &&
            this.deshabilitarSeccion(id_seccion, fila.accion, estado_seccion) // id, accion, estado de pallet
        );
      } else if (fila.accion == "Eliminar") {
        /*

        */
        this.$vToastify
          .prompt(`¿Desea eliminar la Sección '${nombre_seccion}'?`)
          .then((respuesta) => respuesta && this.eliminarSeccion(id_seccion));

        /*

        */
      }
    },

    async eliminarSeccion(id) {
      let sql = await deleteSeccion({ id });

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataSeccionesDB = await getSecciones();

        // Actualizar los datos del dataTable
        this.actionSetDataSecciones(dataSeccionesDB.data_table);

        this.dataTableAux = dataSeccionesDB.data_table;

        this.$vToastify.success(
          "Sección eliminada correctamente",
          "¡Realizado!"
        );

        this.actualizacionGenerarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },

    async deshabilitarSeccion(id, accion, estado) {
      //
      let sql = await activarDesactivarSeccion({ id, estado });

      let texto = accion == "Activar" ? "activada" : "desactivada";

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataSeccionesDB = await getSecciones();

        // Actualizar los datos del dataTable
        this.actionSetDataSecciones(dataSeccionesDB.data_table);

        this.$vToastify.success(
          "Sección " + texto + " correctamente",
          "¡Realizado!"
        );

        this.actualizacionGenerarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },
  watch: {
    data: function (_new) {
      let me = this;

      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        me.dataTableAux = _new;
        this.actualizacionGenerarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
